import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
  getTwitterAuthUrl,
  login as loginApi,
  getNonce,
  unbind,
  bindTwitter,
} from '@src/service/auth'
import { AccountInfo, TwitterBind } from '@src/types/account'
import { getAccountInfo, setAccountInfo } from '@src/utils/jwt'
import { Role } from '@src/types/common/common'

const initialAccountState: {
  accountInfo: AccountInfo | null
} = {
  accountInfo: getAccountInfo() || {
    token: '',
    refreshToken: '',
    expiration: 0,
    user: {
      name: '',
      role: Role.USER,
      solanaAddress: '',
      avatar: '',
    },
  },
}

const account = createSlice({
  name: 'account',
  initialState: initialAccountState,
  reducers: {
    updateAccountInfo: (state, action) => {
      state.accountInfo = action.payload
      setAccountInfo(action.payload)
    },
    logout: (state) => {
      state.accountInfo = null
      setAccountInfo(null)
    },
  },
})

export const fecthTwitterBind = createAsyncThunk(
  'account/fecthTwitterBind',
  async (data: TwitterBind) => {
    const response = await bindTwitter(data)
    return response
  },
)
export const fecthTwitterUnBind = createAsyncThunk(
  'account/fecthTwitterUnBind',
  async (id: number) => {
    const response = await unbind(id)
    return response
  },
)

export const login = createAsyncThunk(
  'account/fetchLogin',
  async (data: { wallet: string; signature: string; referralCode?: string }) => {
    const response = await loginApi(data)
    return response
  },
)

export const fecthNonce = createAsyncThunk('account/getNonce', async (wallet: string) => {
  const { data } = await getNonce(wallet)
  return data.nonce
})
export const fecthTwitterAuthUrl = createAsyncThunk('account/getTwitterAuthUrl', async () => {
  const response = await getTwitterAuthUrl()
  return response
})

export const { updateAccountInfo, logout } = account.actions
export default account.reducer
